/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/23/2023
 */
import React, { useState, useEffect } from "react";
import labelsEN from "../../../../locales/en/translation.json";
import CreateNewGroupsModal from "./components/CreateNewGroupsModal";
import { Box, Button, Fab } from "@mui/material";
import { filterGridSx, filterActionsSx } from "../../components/filterLayout";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Tabs, Tab, Badge } from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import ApprovedGroups from "./components/ApprovedGroups";
import PendingGroups from "./components/PendingGroups";
import OrgsDropdown from "../../components/orgsDropdown/OrgsDropdown";
import { useLocation } from "react-router-dom";

const Groups = () => {
  const AUTO_APPROVE = localStorage.getItem("SET_AUTO_APPROVE")

  const [pendingCount, setPendingCount] = useState(0);
  const [isChange, setIsChange] = useState(false);
  const [isPendingChange, setIsPendingChange] = useState(false);
  const [updateData, setUpdateData] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)

  //modals state
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [orgCode, setOrgCode] = useState();

  // Show/Hide Dropdown
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      setOrgCode(location.state.orgCode);
    }
  }, []);

  const handleChange = (event) => {
    const value = event?.target?.value;
    setOrgCode(value);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
        <h1>{labelsEN.app_group_page_title}</h1>
        <Fab
          onClick={() => setCreateModalOpen(true)}
          color="success"
          variant="extended"
        >
          <AddIcon sx={{ mr: 1 }} />
          Create new
        </Fab>
      </div>
      <Box sx={{ ...filterGridSx, mt: 3 }}>
        <OrgsDropdown
          orgCode={orgCode ? orgCode : ""}
          onChange={handleChange}
        />
      </Box>
      <Box sx={filterActionsSx}>
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          disabled={!orgCode}
          onClick={() => setRefreshKey((value) => value + 1)}
        >
          Refresh
        </Button>
      </Box>
      <div>
        <Tabs
          defaultActiveKey="Approved"
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          <Tab eventKey="Approved" title={"Approved"}>
            <ApprovedGroups
              refreshKey={refreshKey}
              updateData={updateData}
              setUpdateData={setUpdateData}
              orgCode={orgCode}
            />
          </Tab>
          {AUTO_APPROVE === "false" && (
            <Tab
              eventKey="Pending"
              title={
                <div>
                  Pending{" "}
                  {pendingCount !== 0 && (
                    <Badge bg="danger">{pendingCount}</Badge>
                  )}
                </div>
              }
            >
              <PendingGroups
                refreshKey={refreshKey}
                updateData={updateData}
                setUpdateData={setUpdateData}
                setPendingCount={setPendingCount}
                orgCode={orgCode}
              />
            </Tab>
          )}
        </Tabs>
      </div>

      <CreateNewGroupsModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        setUpdateData={setUpdateData}
        orgCode={orgCode}
        setOrgCode={setOrgCode}
      />
    </div>
  )
};
export default Groups;
